import { API_URLS } from "../constants";
import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { MANAGER } = API_URLS;

//Getting all stores by manager id
const getAllStoresByManagerId = (body, managerId) => {
  return postRequest(
    `${MANAGER.GET_ALL_STORES_BY_MANAGER_ID}/${managerId}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting Manager details by Manager Id
const getManagerDetails = (managerId) => {
  return getRequest(`${MANAGER.GET_MANAGERS_BY_ID}/${managerId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const managerProfileService = {
  getManagerDetails,
  getAllStoresByManagerId,
};
